import React, { useMemo, useState } from "react";

/**
 * Participant check-in QR (encodes User._id). Same code as confirmation/reminder emails.
 * Served by GET /getParticipantCheckInQR.
 */
const QR_DISPLAY_SIZE = 120;
const QR_API_SIZE = 200;

function ParticipantCheckInQRCode({ userId, accountId, serverUrl, size = QR_DISPLAY_SIZE, className = "" }) {
  const [loadFailed, setLoadFailed] = useState(false);

  const qrSrc = useMemo(() => {
    if (!userId || !accountId || !serverUrl) return "";
    const displaySize = Math.min(200, Math.max(96, size));
    const apiSize = Math.min(512, Math.max(QR_API_SIZE, displaySize * 2));
    const params = new URLSearchParams({
      userId: String(userId),
      accountId: String(accountId),
      size: String(apiSize),
    });
    return `${serverUrl.replace(/\/$/, "")}/getParticipantCheckInQR?${params.toString()}`;
  }, [userId, accountId, serverUrl, size]);

  if (!qrSrc) return null;

  const displaySize = Math.min(200, Math.max(96, size));

  if (loadFailed) {
    return (
      <p className="ParticipantCheckInQRCode-unavailable" role="status">
        Unable to load check-in code. Try again later.
      </p>
    );
  }

  return (
    <div className={className}>
      <img
        src={qrSrc}
        alt="Participant check-in QR code"
        width={displaySize}
        height={displaySize}
        style={{ display: "block" }}
        onError={() => setLoadFailed(true)}
      />
    </div>
  );
}

export default ParticipantCheckInQRCode;
